import type { IconSvgObject } from './types';

const LogoutSquare01Icon: IconSvgObject = [
  ["path", { d: "M14.5 18V20C14.5 20.8284 13.8284 21.5 13 21.5H4C3.17157 21.5 2.5 20.8284 2.5 20V4C2.5 3.17157 3.17157 2.5 4 2.5H13C13.8284 2.5 14.5 3.17157 14.5 4V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 15.5L21.5 12L18 8.5M20.5 12H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LogoutSquare01Icon;
